/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */
import { Dom } from "../../dom/dom.js";
/**
 * Define element is selection helper
 * @deprecated use Dom.isMarker instead
 */
export function isMarker(elm) {
    return Dom.isMarker(elm);
}
